import type { UseQueryOptions } from '@tanstack/react-query';
import type { EditorContentVersion } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';

interface EditorVersionHistoryReturnValue {
  list: EditorContentVersion[];
}

export function getEditorVersionHistory(id: string): Promise<EditorVersionHistoryReturnValue> {
  return FetchPromise.get(`versions/${id}`);
}

export function useEditorVersionHistoryQuery(
  { id }: { id: string },
  queryOptions: UseQueryOptions<EditorVersionHistoryReturnValue, JQuery.jqXHR> = {},
) {
  return useQuery({
    queryKey: ['text-editor-version-history', id],
    queryFn: () => getEditorVersionHistory(id),
    ...queryOptions,
  });
}
